import React from 'react';

import { DropdownTrigger } from '@atlassian/entry-points/dropdown-trigger';

import { loadingDropdownEntryPoint } from '../fixtures/constellation/loading-dropdown-entry-point';
import { RelayWrapper } from '../utils/wrapper';

export default function DropdownTriggerLoading(): React.JSX.Element {
	return (
		<RelayWrapper>
			<DropdownTrigger
				entryPoint={loadingDropdownEntryPoint}
				trigger="Page actions"
				menuLabel="Page actions"
				loadingText="Loading page actions"
				shouldRenderToParent
			/>
		</RelayWrapper>
	);
}
